import React from "react";

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return <div className="home-dark2 layout tt-magic-cursor">{children}</div>;
};

export default Layout;
